// src/services/supportService.js
import {
  collection, doc, addDoc, updateDoc, onSnapshot,
  query, orderBy, serverTimestamp, setDoc, increment,
} from "firebase/firestore";
import { db } from "./firebase";

const CHATS = "supportChats";

export async function sendMessage(userId, userName, text, senderRole, senderName) {
  await addDoc(collection(db, CHATS, userId, "messages"), {
    text, senderRole, senderName,
    createdAt: serverTimestamp(),
    read: senderRole === "admin",
  });
  await setDoc(doc(db, CHATS, userId), {
    userId, userName,
    lastMessage: text,
    lastMessageAt: serverTimestamp(),
    lastSender: senderRole,
    adminUnread: senderRole === "client" ? increment(1) : 0,
  }, { merge: true });
}

export async function markChatAsRead(userId) {
  await updateDoc(doc(db, CHATS, userId), { adminUnread: 0 });
}

export function subscribeToMessages(userId, callback, onError) {
  const q = query(collection(db, CHATS, userId, "messages"), orderBy("createdAt", "asc"));
  return onSnapshot(q,
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
    err  => { console.error("subscribeToMessages:", err.code); onError?.(err); }
  );
}

export function subscribeToAllChats(callback, onError) {
  return onSnapshot(collection(db, CHATS),
    snap => callback(
      snap.docs
        .map(d => ({ id: d.id, ...d.data() }))
        .sort((a, b) => (b.lastMessageAt?.seconds ?? 0) - (a.lastMessageAt?.seconds ?? 0))
    ),
    err => { console.error("subscribeToAllChats:", err.code); onError?.(err); }
  );
}

export function subscribeUnreadCount(callback) {
  return onSnapshot(collection(db, CHATS),
    snap => callback(snap.docs.reduce((s, d) => s + (d.data().adminUnread || 0), 0))
  );
}
